import {
  Button,
  Input,
  notification,
  Card,
  Modal,
  Radio,
  Space,
  Progress,
  Checkbox,
} from "antd";
import QuizIcon from "@mui/icons-material/Quiz";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useState, useEffect } from "react";
import { useStateValue } from "../../../../Reducer/reducer";
import "./ManualAssessment.css";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router";
import axios from "axios";
import { AssesmentUrl, BaseUrl } from "../../../Constants/Constants";
import { actionTypes } from "../../../../Reducer/StateProvider";
import { message } from "antd";

const { TextArea } = Input;

const ManualAssessment = () => {
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const { id, assessmentId } = useParams();

  const profileDetails = JSON.parse(localStorage.getItem("Profile"));
  const userId = profileDetails.user_id;

  const [timer, setTimer] = useState(1200);

  const openNotificationWithIconError = (type) => {
    api["error"]({
      message: "Oops!!!",
      description: type,
    });
  };

  const openNotificationWithIconWarning = (type) => {
    api["warning"]({
      message: "Warning!!!",
      description: type,
    });
  };

  const [{ UserID, Questions }, dispatch] = useStateValue();

  const openAlert = (type) => {
    Swal.fire({
      title: "Alert!!!",
      text: type,
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "OK",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(`/courses`);
      }
    });
  };

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  // fbdDescriptions stores per-question description text (only used for fbd type)
  const [fbdDescriptions, setFbdDescriptions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [resultModal, setResultModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [localQuestions, setLocalQuestions] = useState([]);
  const [status, setStatus] = useState([]);
  const [questionColors, setQuestionColors] = useState([]);
  const [viewedStatus, setViewedStatus] = useState([]);

  // Fetch questions if not available in reducer
  useEffect(() => {
    if (Questions && Questions.length > 0) {
      setLocalQuestions(Questions);
      setAnswers(Array(Questions.length).fill(""));
      setFbdDescriptions(Array(Questions.length).fill(""));
      setStatus(new Array(Questions.length).fill("unanswered"));
      setQuestionColors(new Array(Questions.length).fill("transparent"));
      setViewedStatus(Array(Questions.length).fill(false));
    } else if (!loading) {
      setLoading(true);
      let body = {
        course_id: id,
        assessment_id: assessmentId,
        user_id: userId,
        no_of_questions: 8,
      };

      axios
        .post(`${AssesmentUrl}manual_get_question`, body)
        .then((res) => {
          console.log(res, "getManualQuestions");
          if (res.data.status === 200) {
            const fetchedQuestions = res.data.gen_questions || [];
            setLocalQuestions(fetchedQuestions);
            setAnswers(Array(fetchedQuestions.length).fill(""));
            setFbdDescriptions(Array(fetchedQuestions.length).fill(""));
            setStatus(new Array(fetchedQuestions.length).fill("unanswered"));
            setQuestionColors(
              new Array(fetchedQuestions.length).fill("transparent"),
            );
            setViewedStatus(Array(fetchedQuestions.length).fill(false));
            dispatch({
              type: actionTypes.SET_Questions,
              Questions: fetchedQuestions,
            });
            setLoading(false);
          } else {
            openNotificationWithIconError("Error Getting Questions!");
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err, "get_manual_questionsError");
          openNotificationWithIconError("Error Getting Questions!");
          setLoading(false);
        });
    }
  }, [Questions, id, assessmentId, userId, dispatch, loading]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        console.log("switched");
        openAlert("Switching Tabs leads to end assessment");
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // Update selected option when question changes
  useEffect(() => {
    if (
      localQuestions &&
      localQuestions.length > 0 &&
      localQuestions[currentQuestionIndex]
    ) {
      const currentAnswer = answers[currentQuestionIndex];
      const questionType = localQuestions[currentQuestionIndex]?.question_type;

      if (questionType === "tf") {
        if (currentAnswer === "True") {
          setSelectedOption("True");
        } else if (currentAnswer === "False") {
          setSelectedOption("False");
        } else {
          setSelectedOption(null);
        }
      } else if (questionType === "ma") {
        setSelectedOption(Array.isArray(currentAnswer) ? currentAnswer : []);
      } else {
        setSelectedOption(currentAnswer || null);
      }
    } else {
      setSelectedOption(null);
    }
  }, [currentQuestionIndex, localQuestions, answers]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds,
    ).padStart(2, "0")}`;
  };

  useEffect(() => {
    let body = {
      assessment_id: assessmentId,
    };

    axios
      .post(`${BaseUrl}assesment/Assesment_details`, body, {
        withCredentials: true,
      })
      .then((res) => {
        let duration = JSON.parse(res.data.data.Assesment_Duration);
        setTimer(duration * 60);
      })
      .catch((err) => {
        console.log(err, "assessment_details_error");
      });
  }, [assessmentId]);

  useEffect(() => {
    if (timer <= 0) {
      submitAssessment(true);
      return;
    }

    const countdown = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1);
    }, 1000);

    return () => clearInterval(countdown);
  }, [timer]);

  const formatQuestion = (questionObj) => {
    if (!questionObj) return "";
    const question = questionObj.question_text || "";

    let formattedQuestion = question.replace(/\\n\s*([a-zA-Z])\./g, "<br/>$1.");
    formattedQuestion = formattedQuestion.replace(
      /(?:^|\s)([a-z])\./g,
      (match, p1) => {
        return match.replace(p1, p1.toUpperCase());
      },
    );
    formattedQuestion = formattedQuestion.replace(
      /\\n(?!\s*[a-zA-Z]\.)/g,
      "<br/>",
    );
    formattedQuestion = formattedQuestion.replace(/\s*<br\/>\s*/g, "<br/>");
    return formattedQuestion;
  };

const handleOptionSelect = (e, questionId) => {
  const selectedValue = e.target.value;
  setSelectedOption(selectedValue);

  const updatedAnswers = [...answers];
  updatedAnswers[currentQuestionIndex] = selectedValue;
  setAnswers(updatedAnswers);

  const updatedStatus = [...status];
  const updatedColors = [...questionColors];

  // For fbd: only mark answered if description is also filled
  const qType = localQuestions[currentQuestionIndex]?.question_type;
  if (qType === "fbd") {
    const descFilled = (fbdDescriptions[currentQuestionIndex] || "").trim() !== "";
    updatedStatus[currentQuestionIndex] = descFilled ? "answered" : "unanswered";
    updatedColors[currentQuestionIndex] = descFilled ? "green" : "transparent";
  } else {
    updatedStatus[currentQuestionIndex] = "answered";
    updatedColors[currentQuestionIndex] = "green";
  }

  setStatus(updatedStatus);
  setQuestionColors(updatedColors);
};

  const handleMultipleAnswerChange = (checkedValues) => {
    setSelectedOption(checkedValues);

    const updatedAnswers = [...answers];
    updatedAnswers[currentQuestionIndex] = checkedValues;
    setAnswers(updatedAnswers);

    const updatedStatus = [...status];
    updatedStatus[currentQuestionIndex] = "answered";
    setStatus(updatedStatus);

    const updatedColors = [...questionColors];
    updatedColors[currentQuestionIndex] = "green";
    setQuestionColors(updatedColors);
  };

 const handleInputChange = (event) => {
  const value = event.target.value;
  setSelectedOption(value);

  const updatedAnswers = [...answers];
  updatedAnswers[currentQuestionIndex] = value;
  setAnswers(updatedAnswers);

  const updatedStatus = [...status];
  const updatedColors = [...questionColors];

  const qType = localQuestions[currentQuestionIndex]?.question_type;
  if (qType === "fbd") {
    const answerFilled = value.trim() !== "";
    const descFilled = (fbdDescriptions[currentQuestionIndex] || "").trim() !== "";
    const bothFilled = answerFilled && descFilled;
    updatedStatus[currentQuestionIndex] = bothFilled ? "answered" : "unanswered";
    updatedColors[currentQuestionIndex] = bothFilled ? "green" : "transparent";
  } else {
    updatedStatus[currentQuestionIndex] = value.trim() !== "" ? "answered" : "unanswered";
    updatedColors[currentQuestionIndex] = value.trim() !== "" ? "green" : "transparent";
  }

  setStatus(updatedStatus);
  setQuestionColors(updatedColors);
};

  // Handler for fbd description text area
 const handleFbdDescriptionChange = (event) => {
  const value = event.target.value;
  const updatedDescriptions = [...fbdDescriptions];
  updatedDescriptions[currentQuestionIndex] = value;
  setFbdDescriptions(updatedDescriptions);

  // Re-check if answer is also filled to update status
  const currentAnswer = answers[currentQuestionIndex];
  const answerFilled =
    currentAnswer !== null &&
    currentAnswer !== undefined &&
    (Array.isArray(currentAnswer)
      ? currentAnswer.length > 0
      : String(currentAnswer).trim() !== "");
  const descFilled = value.trim() !== "";
  const bothFilled = answerFilled && descFilled;

  const updatedStatus = [...status];
  updatedStatus[currentQuestionIndex] = bothFilled ? "answered" : "unanswered";
  setStatus(updatedStatus);

  const updatedColors = [...questionColors];
  updatedColors[currentQuestionIndex] = bothFilled ? "green" : "transparent";
  setQuestionColors(updatedColors);
};

  const handleLeavingQuestion = () => {
    const currentQ = currentQuestionIndex;
    const currentAnswer = answers[currentQ];

    const isUnanswered =
      currentAnswer === null ||
      currentAnswer === undefined ||
      (typeof currentAnswer === "string" && currentAnswer.trim() === "") ||
      (Array.isArray(currentAnswer) && currentAnswer.length === 0);

    if (isUnanswered && status[currentQ] === "unanswered") {
      const updatedStatus = [...status];
      updatedStatus[currentQ] = "viewed-unanswered";
      setStatus(updatedStatus);

      const updatedColors = [...questionColors];
      updatedColors[currentQ] = "red";
      setQuestionColors(updatedColors);
    }
  };

  const handleNextQuestion = () => {
    handleLeavingQuestion();

    if (currentQuestionIndex < localQuestions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setCurrentQuestion((prevQuestion) => prevQuestion + 1);
    }
  };

  const handlePreviousQuestion = () => {
    handleLeavingQuestion();

    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      setCurrentQuestion((prevQuestion) => prevQuestion - 1);
    }
  };

 const allQuestionsAnswered = () => {
  return localQuestions.every((q, index) => {
    const answer = answers[index];
    const answerFilled = (() => {
      if (!answer && answer !== 0) return false;
      if (Array.isArray(answer)) return answer.length > 0;
      if (typeof answer === "string") return answer.trim() !== "";
      return true;
    })();

    // For fbd questions, also require the description box to be filled
    if (q.question_type === "fbd") {
      const descFilled = (fbdDescriptions[index] || "").trim() !== "";
      return answerFilled && descFilled;
    }

    return answerFilled;
  });
};

  const submitAssessment = (isAutoSubmit = false) => {
    const updatedAnswers = localQuestions.map((q, index) => {
      const answerObj = {
        question_id: q.question_id,
        answer: answers[index] ?? null,
      };

      // Include fbd_description only for fbd question type
      if (q.question_type === "fbd") {
        answerObj.fbd_description = fbdDescriptions[index] ?? "";
      }

      return answerObj;
    });

    let body = {
      course_id: id,
      assessment_id: assessmentId,
      user_id: userId,
      no_of_questions: 8,
      user_answer: updatedAnswers,
    };

    axios
      .post(`${AssesmentUrl}manual_user_response`, body)
      .then((res) => {
        console.log(res, "manual_validation_response");

        if (res?.data?.status === 200) {
          const data = res?.data;
          const passStatus = data?.pass_status;
          const attempt = data?.assessment_attempt || 1;

          let userScore = 0;
          let totalScore = 0;

          if (data?.score) {
            const [s, t] = data.score.split("/");
            userScore = Number(s) || 0;
            totalScore = Number(t) || 0;
          }

          if (passStatus === "Pass") {
            message.success("You have Successfully completed the course", 6);

            axios
              .post(
                `${BaseUrl}courses/completed`,
                {
                  userId: userId,
                  courseId: id,
                  eligibility: "Pass",
                },
                { withCredentials: true },
              )
              .then((res) => {
                console.log("Completion API response:", res.data);
              })
              .catch((err) => {
                console.error("Error calling completion API", err);
              });
          } else {
            if (attempt <= 1) {
              message.warning(
                "Your recent attempt didn't meet the criteria. Please re-attempt.",
                8,
              );
            } else {
              message.error(
                "Your second and final attempt did not meet the minimum requirements.",
                6,
              );
            }

            axios
              .post(
                `${BaseUrl}courses/completed`,
                {
                  userId: userId,
                  courseId: id,
                  eligibility: "Fail",
                },
                { withCredentials: true },
              )
              .then((res) => {
                console.log("Completion API response:", res.data);
              })
              .catch((err) => {
                console.error("Error calling completion API for fail case", err);
              });
          }

          navigate(`/courses/${id}/assessment/${assessmentId}/manualresult`, {
            state: { userScore, totalScore },
          });
        } else {
          openNotificationWithIconError("Error submitting assessment!");
        }
      })
      .catch((err) => {
        console.log(err, "manual_validation_error");
        openNotificationWithIconError("Error submitting assessment!");
      });
  };

  const handleFinish = () => {
    if (!allQuestionsAnswered()) {
      openNotificationWithIconWarning(
        "Please answer all questions before submitting.",
      );
      return;
    }

    submitAssessment(false);
  };

  const handleSelectedQuestion = (questionId) => {
    handleLeavingQuestion();
    const questionIndex = questionId - 1;
    setCurrentQuestionIndex(questionIndex);
    setCurrentQuestion(questionIndex);
  };

  const questionChart = localQuestions.map((_, index) => index + 1);
  const rowsOfNumbers = [];
  for (let i = 0; i < questionChart.length; i += 5) {
    rowsOfNumbers.push(questionChart.slice(i, i + 5));
  }

  if (loading) {
    return (
      <div
        className="mcqMainDiv"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
        }}
      >
        {contextHolder}
        <div>Loading questions...</div>
      </div>
    );
  }

  if (!localQuestions || localQuestions.length === 0) {
    return (
      <div
        className="mcqMainDiv"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
        }}
      >
        {contextHolder}
        <div>
          <h2>No questions available</h2>
          <Button
            onClick={() =>
              navigate(`/courses/${id}/assessment/${assessmentId}`)
            }
          >
            Go Back
          </Button>
        </div>
      </div>
    );
  }

  const currentQuestionData = localQuestions[currentQuestionIndex];
  const questionType = currentQuestionData?.question_type;

  // Shared FBD Description TextArea rendered below the answer input
  const renderFbdDescriptionBox = () => (
    <div style={{ marginTop: "20px" }}>
      <label
        style={{
          display: "block",
          fontWeight: 600,
          fontSize: "15px",
          color: "#1f2937",
          marginBottom: "8px",
        }}
      >
        Explanation for your answer
        {/* {currentQuestionData?.fbd_description || "Explain why your selected answer is correct"} */}
        <span style={{ color: "#ef4444", fontWeight: 400 }}>*</span>
      </label>
      <TextArea
        rows={4}
        placeholder="Please explain why your selected answer is correct..."
        value={fbdDescriptions[currentQuestionIndex] || ""}
        onChange={handleFbdDescriptionChange}
        style={{
          borderRadius: "12px",
          fontSize: "15px",
          border: "2px solid rgba(102, 126, 234, 0.2)",
          transition: "all 0.3s ease",
          resize: "vertical",
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#667eea";
          e.target.style.boxShadow = "0 0 0 3px rgba(102, 126, 234, 0.1)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "rgba(102, 126, 234, 0.2)";
          e.target.style.boxShadow = "none";
        }}
        maxLength={1000}
        showCount
      />
    </div>
  );

  // Function to render question input based on type
  const renderQuestionInput = () => {
    if (!currentQuestionData) return null;

    switch (questionType) {
      case "ma":
        return (
          <Checkbox.Group
            value={selectedOption || []}
            onChange={handleMultipleAnswerChange}
            className="mcqCheckboxGroup"
          >
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              {currentQuestionData?.options?.map((option, index) => (
                <div key={index} className="mcqOptionItem checkboxOption">
                  <Checkbox value={option} className="mcqCheckbox">
                    <span className="mcqOptionText">{option}</span>
                  </Checkbox>
                </div>
              ))}
            </Space>
          </Checkbox.Group>
        );

      case "mcq":
      case "tf":
      case "img":
      case "ml":
      case "table_q":
        return (
          <Radio.Group
            onChange={(e) =>
              handleOptionSelect(e, currentQuestionData?.question_id)
            }
            value={selectedOption}
            className="mcqRadioGroup"
          >
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              {currentQuestionData?.options?.map((option, index) =>
                option !== null && option !== "" ? (
                  <div key={index} className="mcqOptionItem radioOption">
                    <Radio value={option} className="mcqRadio">
                      <span className="mcqOptionText">{option}</span>
                    </Radio>
                  </div>
                ) : null,
              )}
            </Space>
          </Radio.Group>
        );

      case "fbd": {
        const hasPipeOptions = currentQuestionData?.options?.some(
          (opt) => opt && typeof opt === "string" && opt.includes("|"),
        );

        if (
          hasPipeOptions ||
          (currentQuestionData?.options &&
            currentQuestionData.options.some((opt) => opt !== null))
        ) {
          return (
            <div>
              <Radio.Group
                onChange={(e) =>
                  handleOptionSelect(e, currentQuestionData?.question_id)
                }
                value={selectedOption}
                className="mcqRadioGroup"
              >
                <Space
                  direction="vertical"
                  size="middle"
                  style={{ width: "100%" }}
                >
                  {currentQuestionData?.options?.map((option, index) =>
                    option !== null && option !== "" ? (
                      <div key={index} className="mcqOptionItem radioOption">
                        <Radio value={option} className="mcqRadio">
                          <span className="mcqOptionText">{option}</span>
                        </Radio>
                      </div>
                    ) : null,
                  )}
                </Space>
              </Radio.Group>

              {/* User description box */}
              {renderFbdDescriptionBox()}
            </div>
          );
        } else {
          return (
            <div>
              <Input
                className="mcqTextInput"
                placeholder="Enter your answer (use | to separate multiple answers)"
                type="text"
                value={selectedOption || ""}
                onChange={handleInputChange}
                size="large"
              />

              {/* User description box */}
              {renderFbdDescriptionBox()}
            </div>
          );
        }
      }

      case "fb": {
        const allOptionsNull = currentQuestionData?.options?.every(
          (opt) => opt === null,
        );

        if (allOptionsNull) {
          return (
            <Input
              className="mcqTextInput"
              placeholder="Enter your answer"
              type="text"
              value={selectedOption || ""}
              onChange={handleInputChange}
              size="large"
            />
          );
        } else {
          return (
            <Radio.Group
              onChange={(e) =>
                handleOptionSelect(e, currentQuestionData?.question_id)
              }
              value={selectedOption}
              className="mcqRadioGroup"
            >
              <Space
                direction="vertical"
                size="middle"
                style={{ width: "100%" }}
              >
                {currentQuestionData?.options?.map((option, index) =>
                  option !== null && option !== "" ? (
                    <div key={index} className="mcqOptionItem radioOption">
                      <Radio value={option} className="mcqRadio">
                        <span className="mcqOptionText">{option}</span>
                      </Radio>
                    </div>
                  ) : null,
                )}
              </Space>
            </Radio.Group>
          );
        }
      }

      default:
        return (
          <Input
            className="mcqTextInput"
            placeholder="Enter your answer"
            type="text"
            value={selectedOption || ""}
            onChange={handleInputChange}
            size="large"
          />
        );
    }
  };

  return (
    <div className="mcqMainDiv">
      {contextHolder}
      <Modal
        className=""
        open={resultModal}
        footer={null}
        onCancel={() => navigate(`/courses`)}
      >
        <h1 style={{ textAlign: "center", color: "red" }}>
          Congratulations!!!
        </h1>
        <p style={{ textAlign: "center" }}>
          You have completed your assessment
        </p>
        <h2 style={{ textAlign: "center", color: "red" }}>
          The result will be sent to you shortly
        </h2>
        <Button
          style={{ marginLeft: "37%" }}
          type="primary"
          onClick={() => navigate(`/courses`)}
        >
          Go to Courses
        </Button>
      </Modal>

      <div className="mcqContainer">
        {/* Left Side - Question Card */}
        <div className="mcqQuestionSection">
          <Card className="mcqQuestionCard">
            {/* Question Header */}
            <div className="mcqQuestionHeader">
              <div className="mcqQuestionHeaderLeft">
                <div className="mcqQuestionNumberBadge">
                  <QuizIcon className="mcqQuestionIcon" />
                  <span className="mcqQuestionNumber">
                    Question {currentQuestionIndex + 1} of{" "}
                    {localQuestions.length}
                  </span>
                </div>
              </div>
              <div className="mcqTimerBadge">
                <AccessTimeIcon className="mcqTimerIcon" />
                <span className="mcqTimerText">{formatTime(timer)}</span>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="mcqProgressBar">
              <Progress
                percent={
                  ((currentQuestionIndex + 1) / localQuestions.length) * 100
                }
                showInfo={false}
                strokeColor={{
                  "0%": "#667eea",
                  "100%": "#764ba2",
                }}
                strokeWidth={8}
              />
            </div>

            {/* Question Content */}
            <div className="mcqQuestionContent">
              <div
                className="mcqQuestionText"
                dangerouslySetInnerHTML={{
                  __html: formatQuestion(currentQuestionData?.question),
                }}
              />

              {/* Display image if present */}
              {currentQuestionData?.question?.image_url &&
                currentQuestionData.question.image_url.length > 0 && (
                  <div className="questionImageContainer">
                    {currentQuestionData.question.image_url.map((img, idx) => (
                      <img
                        key={idx}
                        src={img}
                        alt={`Question ${currentQuestionIndex + 1}`}
                        style={{
                          maxWidth: "100%",
                          height: "400px",
                          display: "block",
                          margin: "10px 0",
                        }}
                      />
                    ))}
                  </div>
                )}

              {/* Answer Options based on question type */}
              <div className="mcqOptionsContainer">{renderQuestionInput()}</div>
            </div>

            {/* Navigation Buttons */}
            <div className="mcqNavigationButtons">
              {currentQuestionIndex > 0 && (
                <Button
                  type="default"
                  onClick={handlePreviousQuestion}
                  className="mcqNavButton prevButton"
                  icon={<ArrowBackIcon />}
                  size="large"
                >
                  Previous
                </Button>
              )}
              {currentQuestionIndex !== localQuestions.length - 1 ? (
                <Button
                  type="primary"
                  onClick={handleNextQuestion}
                  className="mcqNavButton nextButton"
                  icon={<ArrowForwardIcon />}
                  size="large"
                >
                  Next Question
                </Button>
              ) : (
                allQuestionsAnswered() && (
                  <Button
                    type="primary"
                    onClick={handleFinish}
                    className="mcqNavButton finishButton"
                    icon={<CheckCircleIcon />}
                    size="large"
                  >
                    Submit Assessment
                  </Button>
                )
              )}
            </div>
          </Card>
        </div>

        {/* Right Side - Question Navigator */}
        <div className="mcqSidebarSection">
          <Card className="mcqSidebarCard">
            <div className="mcqSidebarHeader">
              <QuizIcon className="mcqSidebarIcon" />
              <h3 className="mcqSidebarTitle">Question Navigator</h3>
            </div>

            <div className="mcqQuestionChart">
              {[...Array(Math.ceil(localQuestions.length / 5)).keys()].map(
                (rowIndex) => (
                  <div key={rowIndex} className="mcqQuestionChartRow">
                    {localQuestions
                      .slice(rowIndex * 5, rowIndex * 5 + 5)
                      .map((_, index) => {
                        const questionId = rowIndex * 5 + index + 1;
                        const questionIndex = questionId - 1;
                        const isAnswered = status[questionIndex] === "answered";
                        const isViewedUnanswered =
                          status[questionIndex] === "viewed-unanswered";
                        const isSelected =
                          currentQuestionIndex === questionIndex;

                        return (
                          <div
                            key={questionId}
                            onClick={() => handleSelectedQuestion(questionId)}
                            className={`mcqQuestionNumberItem ${
                              isSelected ? "selected" : ""
                            } ${
                              isAnswered
                                ? "answered"
                                : isViewedUnanswered
                                ? "viewedUnanswered"
                                : "unanswered"
                            }`}
                          >
                            {questionId}
                          </div>
                        );
                      })}
                  </div>
                ),
              )}
            </div>

            <div className="mcqLegend">
              <div className="mcqLegendItem">
                <div className="mcqLegendColor answered"></div>
                <span>Answered</span>
              </div>
              <div className="mcqLegendItem">
                <div className="mcqLegendColor viewedUnanswered"></div>
                <span>Not Answered</span>
              </div>
              <div className="mcqLegendItem">
                <div className="mcqLegendColor unanswered"></div>
                <span>Not Visited</span>
              </div>
            </div>

            <div className="mcqTimerCard">
              <div className="mcqTimerContent">
                <AccessTimeIcon className="mcqTimerLargeIcon" />
                <div className="mcqTimerInfo">
                  <span className="mcqTimerLabel">Time Remaining</span>
                  <span className="mcqTimerValue">{formatTime(timer)}</span>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ManualAssessment;